import './styles/main.css';
import { initApp } from './ui/app';

// Initialize application on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}
